var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3CC76A39-2C1D-4D67-9FC3-57BB09240FD0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Truck-Report---GMSA",
    transform: "translate(-123.000000, -172.000000)",
    stroke: "#C00000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Truck",
    transform: "translate(124.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.37631581,11.7718237 L1.35384615,11.7718237 L1.35384615,11.7718237 C1.38836817,12.0518376 1.43231199,12.2461231 1.48567763,12.3546803 C1.53904327,12.4632374 1.62645174,12.6227722 1.74790304,12.8332848 L0.37631581,12.8332848 C0.168482327,12.8332848 -3.00588903e-17,12.6648024 0,12.456969 L0,12.1481396 C3.00588903e-17,11.9403061 0.168482327,11.7718237 0.37631581,11.7718237 Z",
    id: "Rectangle",
    strokeWidth: 0.55000003,
    fill: "#E6EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76315789,0 L13.6052632,0 C14.0848789,-8.81039755e-17 14.4736842,0.388805349 14.4736842,0.868421053 L14.4736842,10.7327935 L14.4736842,10.7327935 L2.89473684,10.7327935 L2.89473684,0.868421053 C2.89473684,0.388805349 3.28354219,-1.33940629e-16 3.76315789,0 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89473684,10.7327935 L22,10.7327935 L22,11.4035478 C22,11.8696262 21.7079633,12.2857415 21.2696499,12.4442041 L21.0487907,12.524051 C20.7187254,12.6433789 20.4383084,12.8701168 20.252528,13.1678883 C20.0741519,13.4537921 19.7609767,13.6275304 19.4239915,13.6275304 L5.5,13.6275304 C4.06115289,13.6275304 2.89473684,12.4611143 2.89473684,11.0222672 L2.89473684,10.7327935 L2.89473684,10.7327935 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4736842,2.20647773 L17.810742,2.20647773 C18.5811356,2.20647773 19.2185166,2.80595122 19.2656949,3.57489879 L19.2978223,4.09853436 C19.3320324,4.65611657 19.4771683,5.20126597 19.724728,5.70204781 C19.9626872,6.18340903 20.3999028,6.53609326 20.9207173,6.66680435 L21.0499012,6.6992262 C21.6083925,6.83939317 22,7.34142909 22,7.91724093 L22,10.7327935 L22,10.7327935 L14.4736842,10.7327935 L14.4736842,2.20647773 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 6.28947376,
    cy: 14.1275304,
    r: 1.9473685
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 17.8684211,
    cy: 14.1275304,
    r: 1.9473685
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.cbfafbcb329aac8636b70011ba87a424.svg";
export { ForwardRef as ReactComponent };